// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require notifications/_namespace
//= require notifications/models/notification
//= require_tree .
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/notifications/_namespace.coffee')
require('sprocket-compat?this!javascripts/notifications/models/notification.coffee')
require('sprocket-compat?this!javascripts/notifications/coauthor_suggestion_behavior.coffee')
require('sprocket-compat?this!javascripts/notifications/collections/notification_collection.coffee')
require('sprocket-compat?this!javascripts/notifications/join_discussion_behavior.coffee')
require('sprocket-compat?this!javascripts/notifications/models/most_recent_notifications.coffee')
require('javascripts/notifications/templates/notification_spinner_JST.wjs.js')
require('javascripts/notifications/templates/notifications_container_JST.wjs.js')
require('javascripts/notifications/templates/notifications_unavailable_JST.wjs.js')
require('sprocket-compat?this!javascripts/notifications/views/container.coffee')
require('sprocket-compat?this!javascripts/notifications/views/list_view.coffee')
// MAGIC_DESPROCKET_END
